import {
    Box,
    Button,
    CircularProgress, Grid,
    Input, InputLabel, Stack,
    Tooltip,
    Typography,
    styled
} from '@mui/material';
import { includes } from 'lodash';
import Plus from 'mdi-material-ui/Plus';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import Stat from 'src/components/mui/chip/stat';
import AddProduct from 'src/views/product/AddProduct';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import PageHeader from '../../components/page-header';
import { useGetProductsQuery } from '../../store/productApi';
import DialogProduct from '../../views/product/DialogProduct';
import TableProduct from '../../views/product/TableProduct';

const LabelWrapper = styled(Box)(({ theme }) => ({
    marginLeft: '48px',
    background: '#90ff90',
    padding: '10px 16px',
    borderRadius: '8px',
    boxShadow: '0px 2px 4px -1px rgb(145 158 171 / 20%), 0px 4px 5px 0px rgb(145 158 171 / 14%), 0px 1px 10px 0px rgb(145 158 171 / 12%)',
    ":hover": { background: '#90ee90' }
}))

const ProductList = () => {
    const [reload, setReload] = useState(0)
    const [selected, setSelected] = useState([])
    const [show, setShow] = useState(false)
    const [showProductInfo, setProductInfo] = useState(false)
    const inputFile = useRef(null);
    const [loading, setLoading] = useState(false)
    const [query] = useState('')    // TBD
    const [productID, setProductID] = useState(0)
    const { refetch } = useGetProductsQuery();
    const [total, setTotal] = useState(0)
    const { data, error } = useGetProductsQuery({
        refetchOnFocus: true
    });
    
    useEffect(() => {
        queryTotal();
    }, [reload]);

    useEffect(() => {
        data && setTotal(data.data)
    }, [data]);

    useEffect(() => {
        !showProductInfo && setProductID(0)
    }, [showProductInfo])

    useEffect(() => {
        productID > 0 && setProductInfo(true)
    }, [productID])

    const queryTotal = async () => {
      try {
        const response = await apiService.get('/products/all/count');
        const payload = response.data;
        setTotal(payload.data);
      } catch (e) {
        console.error(e);
      }
    }

    const sheetDownload = async () => {
        try {
            const response = await apiService.get('/products/download', {
                responseType: 'blob',
                params: {
                    query
                }
            });
            const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "제품리스트.xlsx";
            document.body.appendChild(a);
            a.click();
        } catch (e) {
            console.error(e);
        }
    }

    const sheetUpload = async (e) => {
        const [file] = Array.from(e.target.files);
        const ext = file.name.split('.').pop().toLowerCase();

        if (inputFile.current) {
            inputFile.current.value = "";
        }

        if (includes(['xls', 'xlsx'], ext)) {
            setLoading(true)

            const formData = new FormData()
            formData.append('file', file);

            try {
                const response = await apiService.postFormData('/products/upload', formData);
                const payload = response.data;

                toast.success('등록 되었습니다');
                refetch();

                setTotal(payload.data.total);
                setReload(reload + 1);
            } catch (error) {
                console.error('Error uploading file:', error);
            } finally {
                setLoading(false);
            }
        } else {
            toast.error('엑셀 xls, xlsx 파일 포맷만 가능합니다.')
        }
    }

    return (
        <Page title="Product">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                        <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                            <Typography variant='h5' color='#666CFF'>
                                상품관리 
                            </Typography>
                            <Stat value={total}/>
                        </Stack>
                    }
                    subtitle={
                        <Typography variant='body2'>
                            상품 리스트를 보여줍니다.
                        </Typography>
                    }
                />
                <Stack direction="row" spacing={4} sx={{ mx: 6, py: 3 }}>
                    <Tooltip title="단수 상품등록">
                        <Link to="/admin/product/new">
                            <Button variant='contained' startIcon={<Plus />} >상품등록</Button>
                        </Link>
                    </Tooltip>
                    {/* <Button variant='contained' color="warning" startIcon={<MicrosoftExcel />} onClick={sheetDownload} >엑셀 다운로드</Button> */}
                    <Tooltip title="일괄 상품등록">
                        <LabelWrapper>
                            <InputLabel htmlFor='excelFile' sx={{ fontSize: '14px', ":hover": {cursor: 'pointer'} }}>
                                {loading ? (
                                <CircularProgress
                                    sx={{
                                    color: 'common.white',
                                    width: '20px !important',
                                    height: '20px !important',
                                    mr: theme => theme.spacing(2)
                                    }}
                                />
                                ) : null}
                                엑셀 상품등록 
                            </InputLabel>
                            <form encType="multipart/form-data" >
                                <Input type="file" id="excelFile" style={{ display: 'none' }} onChange={sheetUpload} inputRef={inputFile} />
                            </form>
                        </LabelWrapper>
                    </Tooltip>
                </Stack>
                <DialogProduct show={showProductInfo} setShow={setProductInfo} setReload={setReload} productID={productID}/>
                <AddProduct show={show} setShow={setShow} setReload={setReload} />
                <Grid item xs={12}>
                    <TableProduct reload={reload} setReload={setReload} selected={selected} setSelected={setSelected} setProductID={setProductID}/>
                </Grid>
            </Grid>
        </Page>
    )
}

export default ProductList